import React, { Component, useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Input, Col, Row, Button, Divider, InputNumber, Select, Tooltip, Typography, DatePicker } from 'antd'
import * as utils from 'utils/index'
import cn from 'classnames'
import dayjs from 'dayjs';
import styles from './styles.module.less'
import moment from 'moment';
import { sendMessage } from '@/models/messages/actions'
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
const { Title } = Typography;
let company = []
for (var key in utils.expressCompanyCode) {
  var value = utils.expressCompanyCode[key]
  company.push({ name: value, id: value })
}
@Form.create()
class AccessoryDialog extends Component {
  state = {
    loading: false,
  }
  handleSubmit = e => {

    let { accessory = {}, order } = this.props
    e.preventDefault();
    if (!accessory) {
      accessory = {}
      accessory.order = order
    }
    const datas = { ...accessory, order: { ...order } }
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      datas.name = values.name
      datas.num = values.num
      datas.reason = values.reason
      datas.expressCompany = values.expressCompany
      datas.expressNo = values.expressNo
      datas.mobile = values.mobile
      datas.deliveryAt = values.deliveryAt
      this.props.submit({ action: 'save', data: datas });/*
      services.saveOrderAccessory(accessory).then(result => {
        message.success('添加成功')
        this.props.form.resetFields()
        onSuccess(result)
      }).catch(err => {
        message.error(err.message || '发生错误')
      }).finally(() => {
        this.setState({
          loading: false
        })
      })*/
    });
  }
  handDelete = e => {
    const { accessory = {} } = this.props
    this.props.submit({ action: 'delete', id: accessory._id });
  }
  getImageWidth = (url) => {
    var img = new Image();
    img.src = url;
    let obj = {}
    // 如果图片被缓存，则直接返回缓存数据
    if (img.complete) {
      obj.width = img.width;
      obj.height = img.height;
      return obj
    } else {
      img.onload = function () {
        obj.width = img.width;
        obj.height = img.height;
        return obj
      }
    }
  }
  previewImage = (images, idx) => {

    const pswpElement = document.querySelectorAll('.pswp')[0];
    const items = images.map((item) => ({
      src: item.url,
      w: item.dimensions ? item.dimensions.width : this.getImageWidth(item.url)?.width,
      h: item.dimensions ? item.dimensions.height : this.getImageWidth(item.url)?.height
    }));
    const options = {
      index: idx,
      history: false,
      tapToClose: false,
    };
    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  }

  shareImg = url => {

    const { accessory = {} } = this.props
    sendMessage({
      order_id: accessory.order,
      message_type: 'image',
      image: url,
    })
  }

  componentDidMount() {

  }
  preview(e) {
    let url = e.target.getAttribute('data-url');
    let height = e.target.getAttribute('data-height');
    let width = e.target.getAttribute('data-width');
    let location = `${url}?x-oss-process=image/resize,m_fill,h_${height},w_${width}/format,webp`
    window.open(location);
  }
  previewPdf(e) {
    let url = e.target.getAttribute('data-url');
    window.open(url);
  }

  render() {
    const { accessory = {}, disabled } = this.props
    const { getFieldDecorator } = this.props.form
    //const disabled = this.state.loading
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    const tailLayout = {
      wrapperCol: { offset: 8, span: 16 },
    };
    return (
      <div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Row>
            <Col >
              <Title level={4}>补发信息填写：</Title>
              <Form.Item
                label="运单号">
                {getFieldDecorator('expressNo', {
                  initialValue: accessory?.expressNo,
                  rules: [
                    {
                      message: '请输入运单号',
                    },
                  ],
                })(
                  <Input
                    placeholder="请输入运单号" style={{ width: 300 }}
                  ></Input>)}
              </Form.Item>
              <Form.Item
                label="快递公司">
                {getFieldDecorator('expressCompany', {
                  initialValue: accessory?.expressCompany,
                  rules: [
                    {
                      message: '请选择快递公司',
                    },
                  ],
                })(
                  <Select showSearch optionFilterProp="title" placeholder="搜索" style={{ width: 300 }
                  }>
                    {
                      company.map(ele => {
                        return <Select.Option key={ele.id} title={ele.name} value={ele.id}>{ele.name}</Select.Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="手机号">
                {getFieldDecorator('mobile', {
                  initialValue: accessory?.mobile,
                  rules: [
                    {
                      required: false,
                      message: '请输入手机号后4位',
                    },
                  ],
                })(
                  <Input
                    placeholder="请输入手机号后4位" style={{ width: 300 }}
                  />
                )}
                <h4><span style={{ fontSize: 10, color: 'red' }}>顺丰速运/丰网速运需填写收件人或寄件人手机号或手机号后四位</span></h4>
              </Form.Item>
              <Form.Item label="发货时间">
                {getFieldDecorator('deliveryAt', {
                  initialValue: accessory?.deliveryAt ? moment(accessory.deliveryAt) : null,
                })(
                  <DatePicker
                    showTime={{ format: 'HH:mm', minuteStep: 5 }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder="选择发货时间"
                  />
                )}
              </Form.Item>
              {/* <Divider></Divider>
              <Title level={4}>师傅反馈的信息：</Title>
              <Form.Item
                label="名称"
                required>
                {getFieldDecorator('name', {
                  initialValue: accessory?.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入配件名称',
                    },
                  ],
                })(
                  <Input disabled={disabled} style={{ width: 300 }} placeholder="请输入配件名称" />
                )}
              </Form.Item>
              <Form.Item
                label="数量"
                required>
                {getFieldDecorator('num', {
                  initialValue: accessory?.num,
                  rules: [
                    {
                      required: true,
                      message: '请输入配件数量',
                    },
                  ],
                })(
                  <InputNumber min={1} disabled={disabled} style={{ width: 300 }} placeholder="请输入配件数量" />
                )}
              </Form.Item>
              <Form.Item
                label="原因">
                {getFieldDecorator('reason', {
                  initialValue: accessory?.reason,
                  rules: [
                    {
                      message: '请输入补发原因',
                    },
                  ],
                })(
                  <Input disabled={disabled} style={{ width: 300 }} placeholder="请输入补发原因" />
                )}
              </Form.Item>
              <Form.Item label="现场图片">
                {accessory?.accessory_images?.map((item, idx) => (
                  <div
                    key={idx}
                    onClick={() => this.previewImage(accessory?.accessory_images, idx)}
                    className={styles.photoItem}
                  >
                    <Tooltip title={item.desc}>
                      <img
                        alt=""
                        className={styles.photoImage}
                        src={item.url}
                      />
                    </Tooltip>
                    <div style={{ textAlign: 'center' }}>
                      <Tooltip title="转发到会话">
                        <span
                          onClick={() => this.shareImg(item.url)}
                          className={cn('iconfont', styles.shareImgBtn)}
                        >
                          &#xe6e7;
                        </span>
                      </Tooltip>
                    </div>
                    <div className={styles.photoTime}>
                      {dayjs(item.createdAt).fromNow()}
                    </div>
                  </div>
                ))}
              </Form.Item> */}
            </Col>
          </Row>
          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
            &nbsp;
            <Button htmlType="button" onClick={() => this.handDelete()}>
              删除
            </Button>
          </Form.Item>
        </Form>
      </div >
    )
  }
}

const addAccessoryDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={600}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <AccessoryDialog onSuccess={hide} {...ownProps} submit={submit} />
  </Modal>
)

export default sagaModal({
  name: 'ORDER_ACCESSORY_DIALOG',
})(addAccessoryDialog)
